import { type ReactElement } from 'react';
import CTNSpinner from '@ctn/ui/components/ctn-spinner';

const Loader = (): ReactElement => (
	<div className="c-jt-loader">
		<CTNSpinner size="size-48" />
		<p className="c-jt-loader__titl">Enviando</p>
		<p className="c-jt-loader__content">El proceso puede tardar unos minutos</p>
	</div>
);

export default Loader;
